import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useI18n } from 'hooks/useI18n';
import { StyledAnchor } from './MethodologyAnchor.styled';

const MethodologyAnchor: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  return (
    <StyledAnchor href="#methodology">
      <FontAwesomeIcon icon={faInfoCircle} />
      {t('methodology-anchor')}
    </StyledAnchor>
  );
};

export default MethodologyAnchor;
